export default __webpack_public_path__ + "static/media/bg-right-1920.5669dbd1.svg";